<div class="media profile-media">
  <img class="b-r-10 profile-pic" [src]="user?.profile_photo_path ? 'https://abnayiy2.s3.me-south-1.amazonaws.com/' + user?.profile_photo_path : 'assets/images/dashboard/profile.png'" alt="">
  <div class="media-body">
    <span *ngIf="translate.currentLang == 'ar'">{{user?.full_name}}</span>
    <span *ngIf="translate.currentLang == 'en'">{{user?.full_name_latin}}</span>
    <p class="mb-0 font-roboto">Admin <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li><a href="/user/view-user-profile/1"><app-feather-icons [icon]="'user'"></app-feather-icons><span>{{ 'Account' | translate}} </span></a></li>
  <li><a href="/my-wallet/details"><app-feather-icons [icon]="'credit-card'"></app-feather-icons><span>{{ 'Wallet' | translate}} </span></a></li>
  <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-out'"></app-feather-icons><span>{{ 'Log Out' | translate }}</span></li>
</ul>